import React from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import BatchesRows from './BatchesRows'
import '../../styles/index.scss'

const LazeCuttingTable = (props) => {

    const { loading, listBatches, onChangeProductType, adminRole } = props

    return (
        <div className='BatchesPageContainer'>
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped'>
                    <thead className='thead-light'>
                        <tr>
                            <th className='Name'>Tên lô</th>
                            <th className="colDate">Ngày tạo</th>
                            <th className="Product-type">Loại sản phẩm</th>
                            <th className="Status">Trạng thái</th>
                            {adminRole &&
                                <th className="Time text-center">Số item cắt</th>
                            }
                            <th className="text-center">Lần cắt</th>
                            <th>Người cắt</th>
                            <th className="info-partner">Đối tác in ép</th>
                            <th className="Time_start">Bắt đầu</th>
                            <th className="Time_end">Kết thúc</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listBatches.length > 0 ? (
                                listBatches.map((item, index) => {
                                    return (
                                        <BatchesRows 
                                            item={item}
                                            onChangeProductType={onChangeProductType} 
                                            key={index}
                                            adminRole={adminRole}
                                        />
                                    )
                                }
                                )
                            ) : (
                                <tr>
                                    <td colSpan={9}>No data</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Spin>
        </div>
    )

}

LazeCuttingTable.propTypes = {
    listBatches: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    onChangeProductType: PropTypes.func
}

export default LazeCuttingTable
